module.exports = __webpack_public_path__ + "img/screenshot_1_body.b7a4cd4f.jpg";